/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import axiosInstance from "../../services/Axios/axios";
import RenderHirePurchasePage from "../RenderHirePurchasePage";

const PAGE_SIZE = 10;

function MartSentSettlements() {
  const history = useHistory();
  const [settlements, setSettlements] = useState([]);
  const [memberProfiles, setMemberProfiles] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const load = async () => {
      setIsLoading(true);
      try {
        const res = await axiosInstance.get(
          "/settlement?status=processed&settlement_type=mart"
        );
        setSettlements(res.data || []);
      } catch {
        toast.error("Failed to load sent mart settlements.");
      } finally {
        setIsLoading(false);
      }

      // Load avatars in the background — does not block the list
      axiosInstance
        .get("/users/members?isPaginated=false&page=1&size=10000")
        .then((res) => {
          const members = res.data?.docs || res.data || [];
          const profileMap = {};
          members.forEach((m) => {
            if (m.staff_id && m.profile_image) profileMap[m.staff_id] = m.profile_image;
          });
          setMemberProfiles(profileMap);
        })
        .catch(() => {});
    };
    load();
  }, []);

  useEffect(() => {
    setCurrentPage(0);
  }, [search]);

  const filtered = settlements.filter((s) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      s.member_name?.toLowerCase().includes(q) ||
      s.staff_id?.toLowerCase().includes(q) ||
      s.loan_id?.toLowerCase().includes(q) ||
      s.loan_officer_name?.toLowerCase().includes(q)
    );
  });

  const pageCount = Math.ceil(filtered.length / PAGE_SIZE);
  const pageItems = filtered.slice(
    currentPage * PAGE_SIZE,
    currentPage * PAGE_SIZE + PAGE_SIZE
  );

  const fmt = (date) =>
    date ? new Date(date).toLocaleDateString("en-GB") : "—";

  const fmtAmount = (amt) =>
    amt != null
      ? "GHS " +
        Number(amt).toLocaleString("en-GH", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "—";

  return (
    <RenderHirePurchasePage title="Sent Mart Settlements">
      <ToastContainer />

      {/* Summary badge */}
      <div className="mb-4">
        <span className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-bold bg-green-50 text-green-700 border border-green-200 dark:bg-green-900/30 dark:text-green-400 dark:border-green-700 transition-colors">
          {filtered.length} Processed Mart Settlement{filtered.length !== 1 ? "s" : ""}
        </span>
      </div>

      {/* Search */}
      <div className="mb-5">
        <input
          type="text"
          placeholder="Search by name, staff ID, reference ID or mart manager..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full max-w-md px-4 py-2.5 bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-600 rounded-xl text-sm text-slate-800 dark:text-slate-100 placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent shadow-sm transition-colors"
        />
      </div>

      {/* Table Card */}
      <section className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-slate-100 dark:border-gray-700 overflow-hidden transition-colors">
        {isLoading ? (
          <div className="text-center py-16 text-slate-400 dark:text-slate-500">
            Loading...
          </div>
        ) : filtered.length === 0 ? (
          <div className="text-center py-16 text-slate-400 dark:text-slate-500">
            No sent mart settlements found.
          </div>
        ) : (
          <>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse text-sm">
                <thead>
                  <tr className="bg-emerald-700 dark:bg-emerald-900">
                    {[
                      "Member",
                      "Staff ID",
                      "Mart Ref ID",
                      "Amount (GHS)",
                      "Issue Date",
                      "Last Payment Date",
                      "Mart Manager",
                      "Status",
                      "Action",
                    ].map((h) => (
                      <th
                        key={h}
                        className="px-4 py-3 text-xs font-bold text-white uppercase tracking-wider border-b-2 border-emerald-800 dark:border-emerald-700 whitespace-nowrap"
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 dark:divide-gray-700">
                  {pageItems.map((s) => (
                    <tr
                      key={s._id}
                      className="hover:bg-slate-50 dark:hover:bg-gray-700/50 transition-colors cursor-pointer"
                      onClick={() =>
                        history.push(`/mart/settlement-detailed?id=${s._id}`)
                      }
                    >
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-3">
                          <img
                            className="w-9 h-9 rounded-full border border-slate-200 dark:border-gray-600 object-cover shadow-sm flex-shrink-0"
                            src={memberProfiles[s.staff_id] || "/images/dev/avatar1.png"}
                            alt={s.member_name}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/images/dev/avatar1.png";
                            }}
                          />
                          <span className="font-semibold text-slate-800 dark:text-slate-100">
                            {s.member_name}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-slate-600 dark:text-slate-300">
                        {s.staff_id}
                      </td>
                      <td className="px-4 py-3 text-slate-600 dark:text-slate-300">
                        {s.loan_id || "—"}
                      </td>
                      <td className="px-4 py-3 font-bold text-emerald-700 dark:text-emerald-400">
                        {fmtAmount(s.amount)}
                      </td>
                      <td className="px-4 py-3 text-slate-600 dark:text-slate-300">
                        {fmt(s.issue_date)}
                      </td>
                      <td className="px-4 py-3 text-slate-600 dark:text-slate-300">
                        {fmt(s.last_expected_payment_date)}
                      </td>
                      <td className="px-4 py-3 text-slate-600 dark:text-slate-300">
                        {s.loan_officer_name || "—"}
                      </td>
                      <td className="px-4 py-3">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-green-50 text-green-700 border border-green-200 dark:bg-green-900/30 dark:text-green-400 dark:border-green-700">
                          Processed
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            history.push(`/mart/settlement-detailed?id=${s._id}`);
                          }}
                          className="px-3 py-1.5 rounded-lg text-xs font-bold text-white bg-blue-600 hover:bg-blue-700 transition-colors"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {pageCount > 1 && (
              <div className="border-t border-slate-100 dark:border-gray-700 flex items-center justify-between px-4 py-3 gap-2 flex-wrap">
                <span className="text-xs text-slate-400 dark:text-slate-500">
                  Showing {currentPage * PAGE_SIZE + 1}–
                  {Math.min(currentPage * PAGE_SIZE + PAGE_SIZE, filtered.length)} of{" "}
                  {filtered.length}
                </span>
                <ReactPaginate
                  breakLabel="..."
                  nextLabel="›"
                  previousLabel="‹"
                  onPageChange={({ selected }) => setCurrentPage(selected)}
                  pageCount={pageCount}
                  forcePage={currentPage}
                  pageRangeDisplayed={5}
                  renderOnZeroPageCount={null}
                  containerClassName="flex items-center gap-1"
                  pageLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                  previousLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                  nextLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                  activeLinkClassName="!bg-indigo-600 !text-white shadow-sm"
                  disabledLinkClassName="opacity-30 cursor-not-allowed"
                />
              </div>
            )}
          </>
        )}
      </section>
    </RenderHirePurchasePage>
  );
}

export default MartSentSettlements;
